import { navigate } from "@reach/router";

import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  removeToken,
} from "../../Common/utils/tokenUtils";
import { CONSTANTS } from "../../config/constants";
import { CHANGE_PASSWORD_PATH } from "../../FLASH-Hire/constants/NavigationConstants";
import { toast } from "react-toastify";

export const userLogout = () => {
  removeToken(ACCESS_TOKEN);
  removeToken(REFRESH_TOKEN);
  localStorage.removeItem("language");
  navigate("/login", { replace: true });
  window.location.reload();
};


export const routeToChangePassword = (message?:string) => {
  const queryParams = new URLSearchParams({
    [CONSTANTS.CHANGE_PASSWORD_PASSWORD_EXPIRED_QUERY_PARAM_FLAG]: "1"
  }).toString();
  navigate(`${CHANGE_PASSWORD_PATH}?${queryParams}`, { replace: true });
}